// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogPostMenu__item--admin":"ii_a","BlogPostMenu__item--moderator":"ii_b"};